import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import ImgLogo from "../../images/logohb.png";

const ModernHeader = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [showScrollTop, setShowScrollTop] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      const scrolled = window.scrollY > 50;
      setIsScrolled(scrolled);
      setShowScrollTop(window.scrollY > 300);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const isActivePath = (path) => {
    return location.pathname === path;
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const navItems = [
    { path: "/", label: "Inicio" },
    { path: "/empresa", label: "Empresa" },
    { path: "/contacto", label: "Contacto" },
  ];

  return (
    <>
      <header className={`modern-header ${isScrolled ? "scrolled" : ""}`}>
        <div className="modern-header-container">
          {/* Logo */}
          <Link to="/" className="modern-header-logo">
            <img src={ImgLogo} alt="Contasi Logo" />
          </Link>

          {/* Desktop Navigation */}
          <nav className="modern-header-nav">
            <ul className="modern-nav-menu">
              {navItems.map((item) => (
                <li key={item.path} className="modern-nav-item">
                  <Link
                    to={item.path}
                    className={`modern-nav-link ${
                      isActivePath(item.path) ? "active" : ""
                    }`}
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>

            {/* Contact Info - Desktop */}
            <div className="modern-header-contact">
              <a
                href="tel:+56961922323"
                className="modern-contact-item"
                title="Llamar ahora"
              >
                <div className="modern-contact-icon">
                  <i className="fas fa-phone"></i>
                </div>
                <span>+56 9 6192 2323</span>
              </a>

              <a
                href="mailto:contacto@contasi.cl"
                className="modern-contact-item"
                title="Enviar email"
              >
                <div className="modern-contact-icon">
                  <i className="fas fa-envelope"></i>
                </div>
                <span>contacto@contasi.cl</span>
              </a>
            </div>

            {/* CTA Button */}
            <div className="modern-header-cta">
              <a
                href="https://wa.me/56961922323"
                className="modern-header-button"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fab fa-whatsapp"></i>
                WhatsApp
              </a>
            </div>
          </nav>

          {/* Mobile Menu Toggle */}
          <button
            className="modern-mobile-menu-toggle"
            onClick={toggleMobileMenu}
            aria-label="Abrir menú"
          >
            <i className="fas fa-bars"></i>
          </button>
        </div>
      </header>

      {/* Mobile Menu */}
      <div className={`modern-mobile-menu ${isMobileMenuOpen ? "open" : ""}`}>
        <div className="modern-mobile-menu-content">
          <div className="modern-mobile-menu-header">
            <img src={ImgLogo} alt="Contasi Logo" style={{ height: "40px" }} />
            <button
              className="modern-mobile-menu-close"
              onClick={closeMobileMenu}
              aria-label="Cerrar menú"
            >
              <i className="fas fa-times"></i>
            </button>
          </div>

          {/* Mobile Navigation */}
          <nav className="modern-mobile-nav-menu">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className="modern-mobile-nav-link"
                onClick={closeMobileMenu}
              >
                {item.label}
              </Link>
            ))}
          </nav>

          {/* Mobile Contact */}
          <div className="modern-mobile-contact">
            <a
              href="tel:+56961922323"
              className="modern-mobile-contact-item"
              onClick={closeMobileMenu}
            >
              <div className="modern-contact-icon">
                <i className="fas fa-phone"></i>
              </div>
              <div>
                <strong>Llamar</strong>
                <br />
                <small>+56 9 6192 2323</small>
              </div>
            </a>

            <a
              href="mailto:contacto@contasi.cl"
              className="modern-mobile-contact-item"
              onClick={closeMobileMenu}
            >
              <div className="modern-contact-icon">
                <i className="fas fa-envelope"></i>
              </div>
              <div>
                <strong>Email</strong>
                <br />
                <small>contacto@contasi.cl</small>
              </div>
            </a>

            <a
              href="https://wa.me/56961922323"
              className="modern-mobile-contact-item"
              target="_blank"
              rel="noopener noreferrer"
              onClick={closeMobileMenu}
            >
              <div className="modern-contact-icon">
                <i className="fab fa-whatsapp"></i>
              </div>
              <div>
                <strong>WhatsApp</strong>
                <br />
                <small>Mensaje directo</small>
              </div>
            </a>
          </div>
        </div>
      </div>

      {/* Scroll to Top Button */}
      <button
        className={`scroll-to-top-modern ${showScrollTop ? "visible" : ""}`}
        onClick={scrollToTop}
        aria-label="Volver al inicio"
      >
        <i className="fas fa-chevron-up"></i>
      </button>
    </>
  );
};

export default ModernHeader;
